import script from "./BoxCount.vue?vue&type=script&setup=true&lang=js"
export * from "./BoxCount.vue?vue&type=script&setup=true&lang=js"

import "./BoxCount.vue?vue&type=style&index=0&id=5f67693e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f67693e"]])

export default __exports__